import { Navigate, Route, Routes } from 'react-router-dom'
import LoginPage from './components/LoginPage'

function NotLoggedInArea() {

    return (
        <div>
            <Routes>
                <Route path="/*" element={<LoginPage />} />
            </Routes>
        </div>
    )
}

export default NotLoggedInArea
